import axios from 'axios';
import {
	ADMIN_DETAILS_GET,
	ADMIN_DETAILS_GET_FAIL,
	ADMIN_DETAILS_SUCCESS,
	DELETE_USER_RESPONSE_SUCCESS,
	ERROR_MESSAGES,
	OTP_VERIFICATION,
	OTP_VERIFICATION_FAIL,
	OTP_VERIFICATION_SUCCESS,
	SUSPEND_USER_RESPONSE_SUCCESS,
	UPDATE_ADMIN_PASSWORD,
	UPDATE_ADMIN_PASSWORD_FAIL,
	UPDATE_ADMIN_PASSWORD_SUCCESS,
	// USER_ADD_ERROR_TYPES,
	USER_LOGIN_FAIL,
	USER_LOGIN_REQUEST,
	USER_LOGIN_SUCCESS,
	USER_LOGOUT,
	USER_REQUEST_ADD,
	USER_REQUEST_EDIT,
	USER_REQUEST_GET,
	USER_REQUEST_PUT,
	USER_REQUEST_SUSPEND,
	USER_RESPONSE_ADD_FAIL,
	USER_RESPONSE_ADD_SUCCESS,
	USER_RESPONSE_EDIT_FAIL,
	USER_RESPONSE_EDIT_SUCCESS,
	USER_RESPONSE_GET_FAIL,
	USER_RESPONSE_GET_SUCCESS,
	USER_RESPONSE_PUT_FAIL,
	USER_RESPONSE_SUSPEND_FAIL,
	USER_LOGIN_FAIL_TOKEN,
	USER_LOGIN_FAIL_ACCOUNT,
	USER_LOGOUT_REQUEST,
	DOWNLOAD_USER_LOGS,
	DOWNLOAD_USER_LOGS_SUCCESS,
	DOWNLOAD_USER_LOGS_FAIL,
	EMAIL_VERIFY_REQUEST,
	EMAIL_VERIFY_SUCCESS,
	EMAIL_VERIFY_FAIL,
	OTP_VERIFY_REQUEST,
	OTP_VERIFY_SUCCESS,
	OTP_VERIFY_FAIL
} from '../constants/userConstants';
import { API_SUCCESS_CODES } from '../constants/commonConstants';
import {
	ENDPOINT_URL,
	LOGIN_API,
	LOGIN_SUCCESS,
	API_RESPONSE_SUCCESS_STATUS_CODE,
	GET_USERS_LIST,
	AUTH_TOKEN_ERROR_STATUS_CODE,
	// AUTH_TOKEN_ERROR_STATUS_MSG,
	TOKEN_FAILED,
	DELETE_USERS,
	BAD_REQUEST_ERROR_CODE,
	SUSPEND_USERS,
	POST_API_RESPONSE_SUCCESS_STATUS_CODE,
	INTERNAL_SERVER_ERROR_STATUS,
	GET_ADMIN_DETAILS,
	UPDATE_PASSWORD_API,
	OTP_VERIFICATION_API,
	USER_PERMISSION,
	TOKEN_EXPIRED,
	UPDATE_PROFILE_LIST,
	LOGOUT_API,
	DOWNLOAD_USER_API,
	GET_EMAIL_API,
	GET_OTP_API
} from '../constants/commonConstants';
import { encryptData, decryptData } from '../utils/crypto';
import { getCookie, setCookie, clearAllCookies } from '../utils/cookieHelper';
import { graphLogin } from '../actions/graphAction/aprecomDetails';
import {
	notifyAddUserToAprecom,
	notifyDeleteUserToAprecom,
} from './apiToNotifyAprecom';
import { getBannerZTPDetails } from '../actions/bannerAction';

/**
 * Handles user login functionality.
 *
 * This function takes an username and password as input parameters and dispatches appropriate actions based on the login result.
 * It dispatches a request action when login process starts, sends a POST request to the server with encrypted user credentials,
 * and dispatches success or failure actions accordingly. Upon successful login, it dispatches success and stores user information in local storage.
 *
 * @param {string} username - User's name.
 * @param {string} password - User's password.
 * @return {function} - Asynchronous function that dispatches Redux actions.
 */

export const login = (username, password, otpVerified = false) => async (dispatch) => {
	try {
		dispatch({
			type: USER_LOGIN_REQUEST,
		});
		let csrfToken = null;
		
		const bannerResponse = await dispatch(getBannerZTPDetails());
		const csrfEnabled = !!bannerResponse?.csrf_enabled && bannerResponse.csrf_enabled === 1;
		console.log('csrfEnabled', csrfEnabled);

		if (csrfEnabled) {
			try {
				const csrfUrl = `${ENDPOINT_URL}api/accounts/csrf/`;
				await axios.get(csrfUrl, {
					withCredentials: true,
				});
				csrfToken = getCookie('csrftoken');
			} catch (err) {
				console.error('Failed to fetch CSRF token:', err);
				throw new Error("CSRF protection is enabled, but token could not be fetched.");
			}
		}

		const body = {
			username,
			password,
			...(otpVerified && { otp_verified: 1 })
		};
		// let body;
		// if(username === 'iCon_debug'){
		// 	 body = {
		// 		username: username,
		// 		password: password,
		// 		otp_verified: 1
		// 	};
		// }else{
		// 	 body = {
		// 		username: username,
		// 		password: password,
		// 	};
		// }		

		const jsonData = JSON.stringify(body);
		const ciphertext = encryptData(jsonData);

		const headers = {};

		if (csrfToken) {
			headers['X-CSRFToken'] = csrfToken;
		}
		
		const config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: ENDPOINT_URL + LOGIN_API,
			headers,
			data: ciphertext,
			...(csrfEnabled && { withCredentials: true }),
		};
		console.log('config', config);

		const { data, headers:responseHeaders } = await axios.request(config);

		const jsonString = decryptData(data);
		const finalResponse = JSON.parse(jsonString);
		localStorage.setItem("info",finalResponse?.message)
		// console.log('finalResponse = ', JSON.stringify(finalResponse, null, 2));
		if (
			finalResponse &&
			finalResponse.status &&
			finalResponse.status === API_RESPONSE_SUCCESS_STATUS_CODE
		) {
			console.log(LOGIN_SUCCESS);
			finalResponse['authorizationToken'] = responseHeaders['authorization'];

			const loginData = finalResponse?.data || finalResponse;
			// login to aprecom
			if (responseHeaders['authorization'] && finalResponse?.data?.is_aprecomm_graph_enabled) {
				dispatch(
					graphLogin({
						username: loginData?.adminUsername,
						tenantName: loginData?.tenant,
						token: responseHeaders['authorization'],
					})
				);
			}
			setCookie({ name: 'timezone', value: encryptData(loginData?.time_zone) });

			setCookie({ name: 'userName', value: encryptData(loginData?.adminUsername) });
			setCookie({ name: 'tenantName', value: encryptData(loginData?.tenant) });
			setCookie({ name: 'adminID', value: encryptData(String(loginData?.adminID))});
			// setCookie({name:'createdAt',value:loginData.createdAt})
			setCookie({ name: 'is_superuser', value: encryptData(String(loginData?.is_superuser))});
			// setCookie({ name: 'is_owner', value: encryptData(String(loginData?.is_owner))});
			setCookie({ name: 'is_ztp', value: encryptData(String(loginData?.is_ztp))});
			setCookie({
				name: 'is_multitenant',
				value: encryptData(String(loginData?.is_multitenant)),
			});
			setCookie({
				name: 'dnd_enable',
				value: encryptData(String(loginData?.dndEnable == 1 ? false : true)),
			});
			setCookie({name: 'is_cnms_lite', value: encryptData(String(loginData?.is_cnms_lite))});
			setCookie({
				name: 'is_rjio',
				value: encryptData(String(loginData?.IS_RJIO ?? '')),
			});
			setCookie({ name: 'msg', value: encryptData(finalResponse?.msg) });
			
			// Create userInfo first so redirect logic can access it
			const requiredUserInfo = {
				authorizationToken: responseHeaders['authorization'],
				data: {
					mfa_enable: loginData?.mfa_enable,
					redirect_url: loginData?.redirect_url,
					permission: loginData?.permission,
				},
			};
			localStorage.setItem('userInfo', encryptData(JSON.stringify(requiredUserInfo)));

			// Only call getUserPermission if there's no redirect_url (same domain login)
			// If redirect_url exists, getUserPermission will be called after redirect in RoutePage
			if (
				finalResponse?.message != 'User is debug' && 
				finalResponse?.data?.mfa_enable !== 1 &&
				!loginData?.redirect_url
			) {
				await getUserPermission(finalResponse);
			}

			dispatch({
				type: USER_LOGIN_SUCCESS,
				payload: LOGIN_SUCCESS,
			});
			localStorage.setItem(
				'permission',
				encryptData(JSON.stringify(finalResponse?.data?.permission))
			);
			localStorage.setItem(
				'featuresAllowed',
				encryptData(JSON.stringify(finalResponse?.data?.features_allowed))
			);
			localStorage.setItem(
				'graph_filters',
				encryptData(JSON.stringify(loginData?.graph_filters || {}))
			);
			// localStorage.setItem(
			// 	'isSuperUser',
			// 	encryptData(String(finalResponse?.data?.is_superuser))
			// );
			localStorage.setItem('is_aprecomm_graph_enabled', String(finalResponse?.data?.is_aprecomm_graph_enabled));
		} else if (
			finalResponse.error &&
			finalResponse.error === TOKEN_EXPIRED
		) {
			dispatch({
				type: USER_LOGIN_FAIL_TOKEN,
				payload: finalResponse.error,
			});
			dispatch(logout());
		} else if (
			finalResponse.error &&
			finalResponse.error.includes('ACCOUNT LOCKED')
		) {
			dispatch({
				type: USER_LOGIN_FAIL_ACCOUNT,
				payload: finalResponse.error,
			});
		} else if (finalResponse.error.includes('ADMIN_LOGIN_INVALID_CRED')) {
			dispatch({
				type: USER_LOGIN_FAIL,
				payload: finalResponse.error,
			});
		} else {
			dispatch({
				type: USER_LOGIN_FAIL,
				payload: finalResponse.error,
			});
		}
	} catch (error) {
		console.log('USER_LOGIN_FAIL error = ', error);
		dispatch({
			type: USER_LOGIN_FAIL,
			payload:
				error?.response && error?.response?.data?.message
					? error?.response?.data?.message
					: error?.message,
		});
	}
};

//  icon degug verification email
export const getEmail = (email) => async (dispatch, getState) => {
	try {
		dispatch({
			type: EMAIL_VERIFY_REQUEST,
		});

		const body = {
			email:email
		};

		const jsonData = JSON.stringify(body);
		const ciphertext = encryptData(jsonData);

		const config = {
			method: 'post',
			url: ENDPOINT_URL + GET_EMAIL_API,
			data: ciphertext,
		};
		config.method = 'post';
		const { data } = await axios.request(config);
		const jsonString = decryptData(data);
		const finalResponse = JSON.parse(jsonString);

		if (finalResponse) {
		
			if (finalResponse.status === API_RESPONSE_SUCCESS_STATUS_CODE) {
				dispatch({
					type: EMAIL_VERIFY_SUCCESS,
					payload: finalResponse
				});
			
			}else if (finalResponse.status == 401) {
				dispatch({
					type: EMAIL_VERIFY_FAIL,
					payload: finalResponse.message
				});
			
			}
			 else {
				dispatch({
					type: EMAIL_VERIFY_FAIL,
					payload: finalResponse.error,
				});
				// dispatch(clear());
			}
		}
	} catch (error) {
		// Handle error
		console.error('Failed:', error);
	}
};
export const getOtp = (email,otp) => async (dispatch) => {
	try {
		dispatch({
			type: OTP_VERIFY_REQUEST,
		});

		const body = {
			email:email,
			otp: otp
		};

		const jsonData = JSON.stringify(body);
		const ciphertext = encryptData(jsonData);

		const config = {
			method: 'post',
			url: ENDPOINT_URL + GET_OTP_API,
			data: ciphertext,
		};
		config.method = 'post';
		const { data } = await axios.request(config);
		const jsonString = decryptData(data);
		const finalResponse = JSON.parse(jsonString);

		if (finalResponse) {
		
			if (finalResponse.success === true ) {
				dispatch({
					type: OTP_VERIFY_SUCCESS,
					payload: finalResponse
				});
			
			}else if (finalResponse.success === false) {
				dispatch({
					type: OTP_VERIFY_FAIL,
					payload: finalResponse?.error
				});
			
			} else if(finalResponse.status === 500)
			{
				dispatch({
					type: OTP_VERIFY_FAIL,
					payload: finalResponse?.message,
				});
			}
			 else {
				dispatch({
					type: OTP_VERIFY_FAIL,
					payload: finalResponse?.error,
				});
				// dispatch(clear());
			}
		}
	} catch (error) {
		// Handle error
		console.error('Failed:', error);
	}
};
/**
 * Logs out the current user.
 *
 * This function removes the user information from local storage,
 * dispatches a logout action to update the Redux store, and redirects
 * the user to the home page ('/').
 *
 * @return {void}
 */

export const logout = (navigate, hideNavbar, skipRedirect = false) => async (dispatch, getState) => {
	try {
		dispatch({
			type: USER_LOGOUT_REQUEST,
		});

		const { } = getState();

		const body = {
			adminId: Number(decryptData(getCookie('adminID'))),
			adminUsername: decryptData(getCookie('userName')),
			createdAt: decryptData(getCookie('createdAt')),
		};

		const jsonData = JSON.stringify(body);
		const ciphertext = encryptData(jsonData);

		const config = {
			method: 'post',
			url: ENDPOINT_URL + LOGOUT_API,
			data: ciphertext,
		};
		config.method = 'post';
		const { data } = await axios.request(config);
		const jsonString = decryptData(data);
		const finalResponse = JSON.parse(jsonString);

		if (finalResponse) {
			if (finalResponse?.error) {
				localStorage.setItem('userlogout', finalResponse.error);
			} else {
				localStorage.setItem('userlogout', finalResponse.msg);
			}
			if (finalResponse.status === API_RESPONSE_SUCCESS_STATUS_CODE) {
				dispatch({
					type: USER_LOGOUT,
					// payload: data.msg,
					payload: {
						showAlert: true,
						alertType: 'error',
						alertMsg: finalResponse.msg},
				});
				
				// Clear storage and cookies after successful logout API call
				localStorage.clear();
				clearAllCookies();
				
				 if (typeof hideNavbar === 'function') {
                    hideNavbar();
					if (navigate) {
					navigate('/');

					setTimeout(() => {
						// Clear again after navigation to ensure all cookies are removed
						localStorage.clear();
						clearAllCookies();					
					}, 2000);
				} else {
					dispatch(clear(skipRedirect));
				}
                }else{
					dispatch(clear(skipRedirect));
				}

			} else {
				dispatch({
					type: USER_LOGOUT,
					payload: finalResponse.error,
				});
				// Clear storage and cookies even on error
				localStorage.clear();
				clearAllCookies();
				dispatch(clear(skipRedirect));
			}
		}else {
			// Clear storage and cookies if no response
			localStorage.clear();
			clearAllCookies();
			dispatch(clear(skipRedirect));
		}
	} catch (error) {
		// Clear storage and cookies on error
		localStorage.clear();
		clearAllCookies();
		dispatch(clear(skipRedirect));
	}
};

export const clear = (skipRedirect = false) => () => {
	// Clear all storage and cookies regardless of skipRedirect
	localStorage.clear();
	clearAllCookies();
	
	// Remove userlogout message if it exists
	try {
		localStorage.removeItem('userlogout');
	} catch {
		// ignore
	}
	
	// Only redirect if skipRedirect is false
	// This allows the interceptor to control redirect logic based on excluded paths
	if (!skipRedirect) {
		document.location.href = '/';
	}
};



/* Action creator for listing users.
 *
 * This function asynchronously dispatches actions to fetch a list of users.
 * It sends a request to the server with optional parameters such as limit and offset.
 * Upon successful response, it dispatches an action with the retrieved data.
 *
 * @param {number} [limit=50] - Optional parameter specifying the maximum number of user entries to fetch.
 * @param {number} [offset=0] - Optional parameter specifying the page no. to fetch the entries from that particular page.
 * @return {function} - Asynchronous function that dispatches actions based on the API response.
 */
export const listUsers =
	(limit = 50, offset = 0, search, queryparam = false) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: USER_REQUEST_GET,
			});

			const { } = getState();
			let url =
				ENDPOINT_URL +
				GET_USERS_LIST;

			if(limit !== null && limit !== undefined){
				url += '?limit=' + limit;
			}
			if(offset !== null && offset !== undefined){
				url = url + '&offset=' + offset;
			}
			if (search && (limit !== null || limit !== undefined) && (offset !== null || offset !== undefined)) {
				url = url + '&search=' + search;
			}
			if (search && (limit === null || limit === undefined) && (offset === null || offset === undefined)) {
				url = url + '?search=' + search;
			}
			if (queryparam){
				url += (url.includes('?') ? '&' : '?') + 'auditloguserlist=' + queryparam;
			}
			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: url,
			};

			const { data } = await axios.request(config);
			const jsonString = decryptData(data);
			const finalResponse = JSON.parse(jsonString);
			console.log(finalResponse, 'final response');
			if (finalResponse && finalResponse.results) {
				dispatch({
					type: USER_RESPONSE_GET_SUCCESS,
					payload: finalResponse,
				});
			}
			if (
				finalResponse &&
				finalResponse.status &&
				finalResponse.status === AUTH_TOKEN_ERROR_STATUS_CODE
			) {
				dispatch({
					type: USER_RESPONSE_GET_FAIL,
					payload: TOKEN_FAILED,
				});
				dispatch(logout());
			}
		} catch (error) {
			const message =
				error?.response && error?.response?.finalResponse?.message
					? error?.response?.finalResponse?.message
					: error?.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
			dispatch({
				type: USER_RESPONSE_GET_FAIL,
				payload: 'Error fetching USERS LIST',
			});
		}
	};

export const downloadUserData =
	(downloadData) => async (dispatch, getState) => {
		try {
			// Dispatch request action
			dispatch({
				type: DOWNLOAD_USER_LOGS,
			});

			const { } = getState();
			const jsonData = JSON.stringify(downloadData);
			const ciphertext = encryptData(jsonData);
			// Configure request
			const config = {
				method: 'get',
				url: ENDPOINT_URL + DOWNLOAD_USER_API,
				data: ciphertext,
			};

			// Send request and get response
			const { data } = await axios.request(config);
			dispatch({
				type: DOWNLOAD_USER_LOGS_SUCCESS,
				payload: data,
			});
			return data;
		} catch (error) {
			// Handle error
			console.error('Failed to downlaod data:', error);
			dispatch({
				type: DOWNLOAD_USER_LOGS_FAIL,
				payload: error.message || 'Failed to downlaod data',
			});
			throw error;
		}
	};
export const deleteUser = (payload) => async (dispatch, getState) => {
	try {
		// Dispatch request action

		dispatch({
			type: USER_REQUEST_PUT,
		});

		
		
		

		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);

		// Configure request
		const config = {
			method: 'put',
			url: ENDPOINT_URL + DELETE_USERS,
			data: ciphertext,
		};

		// Send request and get response
		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);

		if (data && data.status === API_RESPONSE_SUCCESS_STATUS_CODE) {
			dispatch({
				type: DELETE_USER_RESPONSE_SUCCESS,
				payload: { statusOnDelete: data, data: data.data },
			});

			dispatch(notifyDeleteUserToAprecom(payload));

			// dispatch(notifyDeleteUserToAprecom({ userName: payload.username }));
		} else if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE 
			// data.error &&
			// data.error === AUTH_TOKEN_ERROR_STATUS_MSG
		) {
			dispatch({
				type: USER_RESPONSE_PUT_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		} else if (
			data &&
			data.status &&
			(data.status === BAD_REQUEST_ERROR_CODE ||
				data.status === INTERNAL_SERVER_ERROR_STATUS) &&
			data.error
		) {
			dispatch({
				type: USER_RESPONSE_PUT_FAIL,
				payload: data.error,
			});
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: USER_RESPONSE_PUT_FAIL,
			payload: message,
		});
	}
};

export const suspendUser = (payload) => async (dispatch, getState) => {
	try {
		// Dispatch request action
		dispatch({
			type: USER_REQUEST_SUSPEND,
		});

		const { } = getState();

		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);

		// Configure request
		const config = {
			method: 'post',
			url: ENDPOINT_URL + SUSPEND_USERS,
			data: ciphertext,
		};

		// Send request and get response
		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('data in api', data);

		if (
			data &&
			data.data &&
			data.status === POST_API_RESPONSE_SUCCESS_STATUS_CODE
		) {
			dispatch({
				type: SUSPEND_USER_RESPONSE_SUCCESS,
				payload: {
					statusOnSuspend: data,
					suspendData: data.data},
			});
			dispatch(listUsers(5));
		} else if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE 
			// data.error &&
			// data.error === AUTH_TOKEN_ERROR_STATUS_MSG
		) {
			dispatch({
				type: USER_RESPONSE_SUSPEND_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		} else if (
			data &&
			data.status &&
			data.status === BAD_REQUEST_ERROR_CODE &&
			data.error
		) {
			dispatch({
				type: USER_RESPONSE_SUSPEND_FAIL,
				payload: data.error,
			});
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: USER_RESPONSE_SUSPEND_FAIL,
			payload: message,
		});
	}
};

export const addUser = (payload) => async (dispatch, getState) => {
	const mapErrors = (errors) => {
		const mappedErrors = [];
		Object.keys(errors).forEach((key) => {
			if (ERROR_MESSAGES[key]) {
				errors[key].forEach((error) => {
					mappedErrors.push(ERROR_MESSAGES[key] || error);
				});
			} else {
				// Handle generic errors
				errors[key].forEach((error) => {
					mappedErrors.push(`name:${key}, error: ${error}`);
				});
			}
		});
		return mappedErrors;
	};
	try {
		// Dispatch request action
		dispatch({
			type: USER_REQUEST_ADD,
		});

		const { } = getState();
		console.log('payload here', payload);
		const jsonData = JSON.stringify(payload);
		console.log('switch json body', jsonData);
		const ciphertext = encryptData(jsonData);
		// Configure request
		const config = {
			method: 'post',
			url: ENDPOINT_URL + GET_USERS_LIST,
			data: ciphertext,
		};

		// Send request and get response
		let { data } = await axios.request(config);

		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('data in api body', data);
		if (
			data &&
			data.status &&
			data.status === POST_API_RESPONSE_SUCCESS_STATUS_CODE
		) {
			console.log('success in add!!!!!', data);
			dispatch({
				type: USER_RESPONSE_ADD_SUCCESS,
				payload: {
					statusOnAdd: data,
					addData: data.data},
			});
			dispatch(notifyAddUserToAprecom({ userName: data.data.username }));
		} else if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE 
			// data.error &&
			// data.error === AUTH_TOKEN_ERROR_STATUS_MSG
		) {
			dispatch({
				type: USER_RESPONSE_ADD_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		} else if (
			data &&
			data.status &&
			(data.status === BAD_REQUEST_ERROR_CODE ||
				data.status === INTERNAL_SERVER_ERROR_STATUS) &&
			data.error
		) {
			console.log('in add fail,,', data);

			dispatch({
				type: USER_RESPONSE_ADD_FAIL,
				payload: data.error,
			});
		} else if (
			data &&
			data.status &&
			data.status === 403 &&
			data.error === 'INVALID_REQUEST'
		) {
			// Handle the 403 error specifically
			console.log('403 Forbidden error detected');
			dispatch({
				type: USER_RESPONSE_ADD_FAIL,
				payload: 'Access denied: INVALID_REQUEST',
			});
		} else if (data.errors) {
			const mappedErrors = mapErrors(data.errors);
			console.log('mapped Errors body', mappedErrors);
			dispatch({
				type: USER_RESPONSE_ADD_FAIL,
				payload: mappedErrors,
			});
		}else{
			dispatch({
				type: USER_RESPONSE_ADD_FAIL,
				payload: data.error,
			});
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: USER_RESPONSE_ADD_FAIL,
			payload: message,
		});
	}
};

export const editUser = (userId, payload) => async (dispatch, getState) => {
	const mapErrors = (errors) => {
		const mappedErrors = [];
		Object.keys(errors).forEach((key) => {
			if (ERROR_MESSAGES[key]) {
				errors[key].forEach((error) => {
					mappedErrors.push(ERROR_MESSAGES[key] || error);
				});
			} else {
				// Handle generic errors
				errors[key].forEach((error) => {
					mappedErrors.push(`name:${key}, error: ${error}`);
				});
			}
		});
		return mappedErrors;
	};
	try {
		// Dispatch request action
		dispatch({
			type: USER_REQUEST_EDIT,
		});

		const { } = getState();
		console.log('payload here', payload);
		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);
		// Configure request
		const config = {
			method: 'patch',
			url: ENDPOINT_URL + GET_USERS_LIST + userId + '/',
			data: ciphertext,
		};

		// Send request and get response
		let { data } = await axios.request(config);

		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('data in api', data);
		if (
			data &&
			data.data &&
			data.status === API_RESPONSE_SUCCESS_STATUS_CODE
		) {
			console.log('success in add!!!!!', data);
			dispatch({
				type: USER_RESPONSE_EDIT_SUCCESS,
				payload: {
					statusOnEdit: data,
					editUserResponse: data.data},
			});
		} else if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE 
			// data.error 
			// data.error === AUTH_TOKEN_ERROR_STATUS_MSG
		) {
			dispatch({
				type: USER_RESPONSE_EDIT_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		} else if (
			data &&
			data.status &&
			(data.status === BAD_REQUEST_ERROR_CODE ||
				data.status === INTERNAL_SERVER_ERROR_STATUS) &&
			data.error
		) {
			console.log('in add fail,,', data);

			dispatch({
				type: USER_RESPONSE_EDIT_FAIL,
				payload: data.error,
			});
		} else if (data.errors) {
			const mappedErrors = mapErrors(data.errors);
			dispatch({
				type: USER_RESPONSE_EDIT_FAIL,
				payload: mappedErrors,
			});
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: USER_RESPONSE_EDIT_FAIL,
			payload: message,
		});
	}
};

export const editProfile = (userId, payload) => async (dispatch, getState) => {
	const mapErrors = (errors) => {
		const mappedErrors = [];
		Object.keys(errors).forEach((key) => {
			if (ERROR_MESSAGES[key]) {
				errors[key].forEach((error) => {
					mappedErrors.push(ERROR_MESSAGES[key] || error);
				});
			} else {
				// Handle generic errors
				errors[key].forEach((error) => {
					mappedErrors.push(`name:${key}, error: ${error}`);
				});
			}
		});
		return mappedErrors;
	};
	try {
		// Dispatch request action
		dispatch({
			type: USER_REQUEST_EDIT,
		});

		const { } = getState();
		console.log('payload here', payload);

		let csrfToken = null;
		const bannerResponse = await dispatch(getBannerZTPDetails());
		const csrfEnabled = !!bannerResponse?.csrf_enabled && bannerResponse.csrf_enabled === 1;

		if (csrfEnabled) {
			try {
				await axios.get(`${ENDPOINT_URL}api/accounts/csrf/`, {
					withCredentials: true,
				});
				csrfToken = getCookie('csrftoken');
			} catch (err) {
				console.error('Failed to fetch CSRF token:', err);
				throw new Error("CSRF protection is enabled, but token could not be fetched.");
			}
		}

		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);


		const headers = {};

		if (csrfToken) {
			headers['X-CSRFToken'] = csrfToken;
		}
				
		// Configure request
		const config = {
	method: 'patch',
	url: ENDPOINT_URL + UPDATE_PROFILE_LIST + `${userId}/`,
	headers,
			data: ciphertext,
			...(csrfEnabled && { withCredentials: true }),
		};

		// Send request and get response
		let { data } = await axios.request(config);

		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('data in api', data);
		if (
			data &&
			data.data &&
			API_SUCCESS_CODES.includes(data?.status)
		) {
			console.log('success in add!!!!!', data);
			dispatch({
				type: USER_RESPONSE_EDIT_SUCCESS,
				payload: {
					successMessageOnEdit: data.msg,
					editUserResponse: data},
			});
		} else if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE &&
			data.error 
			// &&
			// data.error === AUTH_TOKEN_ERROR_STATUS_MSG
		) {
			dispatch({
				type: USER_RESPONSE_EDIT_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		} else if (
			data &&
			data.status &&
			(data.status === BAD_REQUEST_ERROR_CODE ||
				data.status === INTERNAL_SERVER_ERROR_STATUS) &&
			data.error
		) {
			console.log('in add fail,,', data);

			dispatch({
				type: USER_RESPONSE_EDIT_FAIL,
				payload: data.error,
			});
		} else if (data.errors) {
			const mappedErrors = mapErrors(data.errors);
			dispatch({
				type: USER_RESPONSE_EDIT_FAIL,
				payload: mappedErrors,
			});
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: USER_RESPONSE_EDIT_FAIL,
			payload: message,
		});
	}
};

export const getAdminDetails = (downloadData) => async (dispatch, getState) => {
	try {
		// Dispatch request action
		dispatch({
			type: ADMIN_DETAILS_GET,
		});

		const { } = getState();

		const jsonData = JSON.stringify(downloadData);
		const ciphertext = encryptData(jsonData);

		// Configure request
		const config = {
			method: 'get',
			url: ENDPOINT_URL + GET_ADMIN_DETAILS,
			data: ciphertext,
		};

		// Send request and get response
		let { data } = await axios.request(config);
		if (data) {
			const jsonString = decryptData(data);
			if (jsonString) {
				data = JSON.parse(jsonString);
			}
			// Dispatch success action with received data
			dispatch({
				type: ADMIN_DETAILS_SUCCESS,
				payload: data.data,
			});
		}else if(data.status === AUTH_TOKEN_ERROR_STATUS_CODE){
			dispatch({
				type: ADMIN_DETAILS_GET_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
	} else {
			dispatch({
				type: ADMIN_DETAILS_SUCCESS,
				payload: {},
			});
		}
	} catch (error) {
		dispatch({
			type: ADMIN_DETAILS_GET_FAIL,
			payload: error.message,
		});
		throw error;
	}
};

export const changePassword = (passwordData) => async (dispatch, getState) => {
	try {
		// Dispatch request action
		dispatch({
			type: UPDATE_ADMIN_PASSWORD,
		});

		const { } = getState();

		let csrfToken = null;
		const bannerResponse = await dispatch(getBannerZTPDetails());
		const csrfEnabled = !!bannerResponse?.csrf_enabled && bannerResponse.csrf_enabled === 1;

		if (csrfEnabled) {
			try {
				await axios.get(`${ENDPOINT_URL}api/accounts/csrf/`, {
					withCredentials: true,
				});
				csrfToken = getCookie('csrftoken');
			} catch (err) {
				console.error('Failed to fetch CSRF token:', err);
				throw new Error("CSRF protection is enabled, but token could not be fetched.");
			}
		}

		const jsonData = JSON.stringify(passwordData);
		const ciphertext = encryptData(jsonData);

		const headers = {};

		if (csrfToken) {
			headers['X-CSRFToken'] = csrfToken;
		}


		const adminID = Number(decryptData(getCookie('adminID')));
		// Configure request
		const config = {
	method: 'patch',
	url: ENDPOINT_URL + UPDATE_PASSWORD_API + `${adminID}/`,
	headers,
			data: ciphertext,
			...(csrfEnabled && { withCredentials: true }),
		};

		// Send request and get response
		let { data } = await axios.request(config);
		if (data) {
			const jsonString = decryptData(data);
			if (jsonString) {
				data = JSON.parse(jsonString);
			}
			if (data.status == AUTH_TOKEN_ERROR_STATUS_CODE) {
				dispatch({
					type: UPDATE_ADMIN_PASSWORD_FAIL,
					payload: data.error,
				});
				dispatch(clear());				
			}
			if (data.status == 400) {
				dispatch({
					type: UPDATE_ADMIN_PASSWORD_FAIL,
					payload: data.error || 'Password Update failed',
				});
				return;
			}
			// Dispatch success action with received data
			dispatch({
				type: UPDATE_ADMIN_PASSWORD_SUCCESS,
				successMessage: 'Password Updated Successfully',
				payload: data.data,
			});
			setTimeout(()=>{
				dispatch(clear());
			},2000)
			
			// dispatch(logout());
		} else {
			dispatch({
				type: UPDATE_ADMIN_PASSWORD_SUCCESS,
				successMessage: 'Password Updated Successfully',
				payload: data.data,
			});
			setTimeout(()=>{
				dispatch(clear());
			},2000)
			// dispatch(clear());
			// dispatch(logout());
		}
	} catch (error) {
		// Handle error
		console.error('Failed to downlaod data:', error);
		dispatch({
			type: UPDATE_ADMIN_PASSWORD_FAIL,
			payload: error.message || 'Failed to downlaod data',
		});
		throw error;
	}
};

export const otp2faVerification = (userData) => async (dispatch, getState) => {
	try {
		// Dispatch request action
		dispatch({
			type: OTP_VERIFICATION,
		});

		const { } = getState();

		// Configure request
		// Configure request
		const jsonData = JSON.stringify(userData);
		const ciphertext = encryptData(jsonData);

		const config = {
			method: 'post',
			url: ENDPOINT_URL + OTP_VERIFICATION_API,
			data: ciphertext,
		};
		config.method = 'post';

		// Send request and get response
		let { data, headers } = await axios.request(config);
		if (data) {
			const jsonString = decryptData(data);
			if (jsonString) {
				data = JSON.parse(jsonString);
			}
			if (data.status == AUTH_TOKEN_ERROR_STATUS_CODE) {
				dispatch({
					type: OTP_VERIFICATION_FAIL,
					payload: TOKEN_EXPIRED,
				});
				dispatch(clear());
			}
			if (data.status != 200 && data.status != 201) {
				dispatch({
					type: OTP_VERIFICATION_FAIL,
					payload: data.error || OTP_VERIFICATION_FAIL,
				});
				return;
			}
			let userObject = localStorage.getItem('userInfo');

			if (userObject) {
				userObject = JSON.parse(decryptData(userObject));

				userObject['authorizationToken'] = headers['authorization'];
				// login to aprecom
				if(headers['authorization'] && localStorage.getItem('is_aprecomm_graph_enabled') === 'true'){
					dispatch(
						graphLogin({
							username: decryptData(getCookie('userName')),
							tenantName: decryptData(getCookie("tenantName")),
							token: headers['authorization'],
						})
					);
				}

				const updatedUserObject = encryptData(JSON.stringify(userObject));
				localStorage.setItem('userInfo', updatedUserObject);
				
				// Only store permission if it exists in userObject.data
				if (userObject?.data?.permission) {
					localStorage.setItem(
						'permission',
						encryptData(JSON.stringify(userObject.data.permission))
					);
				}

				const hasRedirectUrl = userObject?.data?.redirect_url && userObject.data.redirect_url.trim() !== '';
				// const hasMfaEnable = userObject?.data?.mfa_enable

				// OTP just succeeded — MFA is already verified. Call permission for
				// same-domain login. Tenant redirect_url flows load permission in RoutePage.
				if (!hasRedirectUrl) {
					await getUserPermission(userObject);
				}
			}
			// Dispatch success action with received data
			dispatch({
				type: OTP_VERIFICATION_SUCCESS,
				payload: data.data,
				verificationSuccessMsg: OTP_VERIFICATION_SUCCESS,
			});
		}
	} catch (error) {
		// Handle error
		console.error('Failed to downlaod data:', error);
		dispatch({
			type: OTP_VERIFICATION_FAIL,
			payload: error.message || 'Failed to downlaod data',
		});
		throw error;
	}
};

export const getUserPermission = async () => {
	try {
		const config = {
			method: 'get',
			url: ENDPOINT_URL + USER_PERMISSION + '?limit=1000',
		};

		// Send request and get response
		const { data } = await axios.request(config);
		if (data) {
			const decryptedData = JSON.parse(decryptData(data));
			localStorage.setItem(
				'rolepermission',
				encryptData(JSON.stringify(decryptedData?.results || []))
			);
			return decryptedData;
		}
	} catch (error) {
		console.log('erooor', error);
		return error;
	}
};
